import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "book-cover__stage" }
const _hoisted_2 = { class: "book-cover__book" }
const _hoisted_3 = { class: "book-cover__face" }
const _hoisted_4 = { class: "book-cover__content" }
const _hoisted_5 = { class: "book-cover__logo" }
const _hoisted_6 = { class: "book-cover__title" }
const _hoisted_7 = { class: "book-cover__publisher" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCover',
  props: {
  color: {
    type: String,
    required: true,
    validator: (value) => ["blue", "purple"].includes(value),
  },
  title: {
    type: String,
    required: true,
  },
  logo: {
    type: String,
    required: true,
  },
  publisher: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const titleLines = computed(() =>
  props.title.split("\n").map((line) => line.trim()).filter(Boolean)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["book-cover", `book-cover--${__props.color}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "book-cover__spine",
          "aria-hidden": "true"
        }, [
          _createElementVNode("span", { class: "book-cover__spine-light" }),
          _createElementVNode("span", { class: "book-cover__spine-groove" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "book-cover__effects",
            "aria-hidden": "true"
          }, [
            _createElementVNode("div", { class: "book-cover__face-shade" }),
            _createElementVNode("div", { class: "book-cover__face-gloss" })
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.logo), 1),
            _createElementVNode("h3", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleLines.value, (line, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "book-cover__title-line"
                }, _toDisplayString(line), 1))
              }), 128))
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.publisher), 1)
          ])
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "book-cover__shadow",
        "aria-hidden": "true"
      }, null, -1))
    ])
  ], 2))
}
}

})